// extracted by mini-css-extract-plugin
export default {"notification":"NotificationWarning_notification__7CD6R","icon":"NotificationWarning_icon__KDA+V"};